export default __webpack_public_path__ + "static/media/tomcrews.09968925.jpg";